import { createSelector } from '@reduxjs/toolkit';
import { selectIsMortgageAvailable } from 'shared/selectors/jsonQuery';

export const selectMortgageAvailableFilter = createSelector(selectIsMortgageAvailable, value => ({
  label: 'Возможна ипотека',
  value: Boolean(value),
}));
